module.exports = "<div class=\"articlePageHeader\">\n    References\n</div>\n\n<div class=\"articleReference\" [innerHTML]=\"references\"></div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/references/references.component.html
// module id = ../../../../../src/app/components/references/references.component.html
// module chunks = main